module.exports = __webpack_public_path__ + "assets/img/poster.8739748c.png";